import React, { useState } from 'react';
import { Box, Button, createStyles, FormControlLabel, makeStyles, Switch, TextField, Typography, } from '@material-ui/core';
import { UserRole } from '@/entities/user';
import { ConfirmDeleteUser } from '../ConfirmDeleteUser';
import { useCreateUser } from '../../services/hooks/use-create-user';
import { useDeleteUser } from '../../services/hooks/use-delete-user';
import { useUpdateUser } from '../../services/hooks/use-update-user';
const useStyles = makeStyles(() => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '800px',
        padding: '72px',
    },
    header: {
        fontWeight: 600,
        marginBottom: '32px',
    },
    input: {
        width: '370px',
        marginBottom: '16px',
    },
    switch: {
        marginLeft: 0,
        marginBottom: '16px',
    },
}));
export const FormAddingUser = ({ isEditing = false, initialState, onSubmit }) => {
    const styles = useStyles();
    const initialFullName = initialState?.fullName ?? '';
    const initialIsAdmin = initialState?.role === UserRole.ADMINISTRATOR;
    const [loginName, setLoginName] = useState('');
    const [fullName, setFullName] = useState(initialFullName);
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [isAdmin, setIsAdmin] = useState(initialIsAdmin);
    const { mutate: updateUser, isLoading: isUpdating } = useUpdateUser(onSubmit);
    const { mutate: createUser, isLoading: isCreating } = useCreateUser(onSubmit);
    const { mutate: deleteUser, isLoading: isDeleting } = useDeleteUser(onSubmit);
    const isLoading = isUpdating || isCreating || isDeleting;
    const trimmedLoginName = loginName.trim();
    const trimmedFullName = fullName.trim();
    const isFullNameChanged = trimmedFullName !== initialFullName;
    const isRoleChanged = isAdmin !== initialIsAdmin;
    const isPasswordTouched = password !== '' || passwordConfirmation !== '';
    const isPasswordMismatched = isPasswordTouched && password !== passwordConfirmation;
    // Редактирование - все поля необязательные, сохраняем только изменения.
    const isSomethingChanged = isFullNameChanged || isRoleChanged || isPasswordTouched;
    // Создание - бэкенд требует все поля.
    const isReadyToCreate = trimmedLoginName !== '' && trimmedFullName !== '' && password !== '';
    const canSave = !isLoading && !isPasswordMismatched && (isEditing ? isSomethingChanged : isReadyToCreate);
    const role = isAdmin ? UserRole.ADMINISTRATOR : UserRole.SERVICE_USER;
    const toggleChecked = () => {
        setIsAdmin((prev) => !prev);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        if (!canSave) {
            return;
        }
        if (!isEditing) {
            createUser({
                fullName: trimmedFullName,
                loginName: trimmedLoginName,
                password,
                role,
            });
            return;
        }
        if (!initialState) {
            return;
        }
        const config = { guid: initialState.guid };
        if (isFullNameChanged) {
            config.fullName = trimmedFullName;
        }
        if (isPasswordTouched) {
            config.password = password;
        }
        if (isRoleChanged) {
            config.role = role;
        }
        updateUser(config);
    };
    return (React.createElement("form", { className: styles.root, noValidate: true, autoComplete: "off", onSubmit: handleSubmit },
        React.createElement(Typography, { className: styles.header, variant: "h4", component: "h2" }, isEditing ? 'Редактирование пользователя' : 'Новый пользователь'),
        React.createElement(TextField, { className: styles.input, variant: "outlined", required: !isEditing, label: "\u041B\u043E\u0433\u0438\u043D", InputProps: { readOnly: isEditing }, value: isEditing ? initialState?.loginName ?? '' : loginName, onChange: (event) => setLoginName(event.target.value) }),
        React.createElement(TextField, { className: styles.input, variant: "outlined", required: !isEditing, label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435", value: fullName, onChange: (event) => setFullName(event.target.value) }),
        React.createElement(TextField, { type: "password", className: styles.input, variant: "outlined", required: !isEditing, label: "\u041F\u0430\u0440\u043E\u043B\u044C", value: password, onChange: (event) => setPassword(event.target.value) }),
        React.createElement(TextField, { type: "password", className: styles.input, variant: "outlined", required: !isEditing, label: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C", value: passwordConfirmation, onChange: (event) => setPasswordConfirmation(event.target.value), error: isPasswordMismatched, helperText: isPasswordMismatched ? 'Пароли не совпадают' : '' }),
        React.createElement(FormControlLabel, { className: styles.switch, control: React.createElement(Switch, { color: "primary", checked: isAdmin, onChange: toggleChecked }), label: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440", labelPlacement: "end" }),
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Button, { type: "submit", variant: "contained", color: "primary", disabled: !canSave }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"),
            isEditing && initialState && (React.createElement(Box, { ml: 2 },
                React.createElement(ConfirmDeleteUser, { disabled: isLoading, onDelete: () => deleteUser(initialState.guid) }))))));
};
